import type { ClobClient } from '@polymarket/clob-client-v2';

import { useClobOrders, useClobTrades } from '@/services/query';

interface UseMarketClobDataProps {
  conditionId: string;
  eoaAddress: string | undefined;
  clobClient: ClobClient | undefined;
  isAuthenticated: boolean;
  isReadyToTrade: boolean;
}

export const useMarketClobData = ({
  conditionId,
  eoaAddress,
  clobClient,
  isAuthenticated,
  isReadyToTrade,
}: UseMarketClobDataProps) => {
  const shouldFetch = !!conditionId && !!clobClient && isAuthenticated && isReadyToTrade;

  const { data: clobOrders, isLoading: isOrdersLoading } = useClobOrders(
    conditionId,
    eoaAddress,
    clobClient,
    shouldFetch
  );

  const { data: clobTrades, isLoading: isTradesLoading } = useClobTrades(
    conditionId,
    eoaAddress,
    clobClient,
    shouldFetch
  );

  return {
    clobOrders,
    isOrdersLoading,
    clobTrades,
    isTradesLoading,
  };
};
